import { Component, OnInit, EventEmitter, Output, 
    HostListener, OnDestroy, ViewContainerRef, 
    ViewChild, ChangeDetectorRef, ElementRef } from '@angular/core';
import * as interact from 'interactjs/dist/interact.js';
import { Subscription ,  Subject } from 'rxjs';

import { environment } from 'environments/environment';
import DesktopConfig from 'modules/desktop/services/config';

import { AuthService } from 'modules/app/services/auth.service';
import { ApiGatewayHelperService } from 'modules/app/services/apigateway-helper.service';
import { ContentHelper } from 'libs-content-helper';
import { ProductViewHelperService } from 'modules/foc/services/product-view-helper.service';
import { ProductTocService } from 'modules/foc/services/product-toc.service';
import { ProductViewDataService } from 'modules/foc/services/product-view-data.service';
import { appSetting } from 'config/appSettings';
import { NetwordDetectionService } from 'modules/app/services/network-detection.service';
import { LODBHelperService } from 'modules/foc/services/lo-db-helper.service';
import { CustomArrayOpsService } from 'modules/app/services/custom-array-ops.service';
import { EventService } from 'modules/app/services/event.service';
import { AppHelperService } from 'modules/app/services/app-helper.service';
import { Router, ActivatedRoute } from '@angular/router';
import { PushXService } from 'modules/shared-postlogin/services/pushx.service';
import { CustomBackendLoggerService } from 'modules/app/services/custom-backend-logger.service';
import { CreateUserAnalyticsService } from 'modules/app/services/create-user-analytics.service';

declare var $:any;
@Component({
	selector: 'app-lo-hotspot',
	templateUrl: './lo-hotspot.template.html',
	styleUrls: ['./lo-hotspot.style.scss']
})

export class LoHotspot implements OnInit, OnDestroy{

	private _isSmallerDevice: boolean = false; // private variable to store is the device is medium tablet or smaller. Used to set the modal features.
	isFullscreen: boolean = false; // variable to track if the modal is in fullscreen mode or not.
    showMobileModal: boolean = false; // variable to store if the device is smaller than 576. Used to set the mobile-modal features.

	@Output() closeLOOutputEvent : EventEmitter<any> = new EventEmitter<any>(); 
    @Output() bringLoWidgetOnTop: EventEmitter<any> = new EventEmitter();


	position = { x: 0, y: 0 };
	orientationChangeCausedResize = false;
    centerModalToScreenAfterOrientationWasChangedWhileInFullScreen = false;
    toggleFullscreenAgainAsOrientationWasChanged = false;
    centerAlignAfterOrientationWasChangedAndNotInFullscreen = false;
    draggableModal:any = undefined;
	contentContainer:any; // used to store the reference of the content container.
	hotspotOverlayModal:any; // used to store the reference of the overlay modal.
    returnBecauseOriginalListenersNowWork:any = true;

	//default config
	inputConfig: {
		data: any, // json data for lo (inside HCM)
		selector: any, // unique selector to create unique modals (HCM)
        component: any,
        spaceId: string
    };

    isTeacher: boolean;
    selectedItem : any = {};
    xapiLOAnalytics: any;
    productTocData: any;
    // bundle code
    productCode: any;
    // astring containing three entities separated by forwards slash "/" 
    // unit_code/leson_code/activity_code
    itemCode: any;
    tocArray: any;
    productMeta: any;
    bundleDetails : any;
    userProfileData: any;
    spaceId: string;
    classId: string;
    isCBPClass: boolean;
    assignmentId: string;
    customDragResize:boolean = false;

    selectedItemSubscription: Subscription;

    showResultScreenEvent:Subject<any> = new Subject();
    /* Boolean to show/hide result screen */
    showResultScreen: boolean = false;

    /* Array to contain all the content controls / buttons visible */
    showControls = [];

    /** Array to specify the relative order of buttons in which they should appear on screen */
    controlOrder = [
        "goPrev", 
        "revealAllAnswers",
        "revealNextAnswer",
        "hideObject",
        "checkAnswers",
        "goNext"
    ];

    /* Boolean to show/hide next activity button */
    showNextActivityBtn: boolean = false;

    /* Boolean to determine if review mode - needed for avallain content */
    isReviewMode = false;   

    /* Boolean to determine if current selected activity is game - needed to hide header and controls */
    isGameActivity: boolean = false;

    isPreviewMode = false;
    selectedItemData : any;

    aboutToExit = false;

    learningpathVisible: boolean = false;
    
    loActivityConfig: {
        productData: any,
        productCode?: string,
        itemId?: string,
		userRole: string,
        metaData        
    };

    isPEDownloaded = false;
    
    zIndexConfig = {
        'topLayer': 3,
        'midLayer': 2,
        'loZindex': 3
    }

    showResizers = false;
    isOnline: boolean;
    showProgressBar = false
    @ViewChild('progressBar') progressBar: ElementRef;
    widthOfProgressBar: number = 0;
    currentTheme:any;
    params: any;

    public imageBasePath: string = IMAGES_BASEPATH;

    @ViewChild('activityHost', { read: ViewContainerRef }) activityHost: ViewContainerRef;
    @ViewChild('closeActivityBtn') closeActivityBtn : ElementRef;

	constructor(
        private authService: AuthService,
        private apiGatewayHelperService: ApiGatewayHelperService, 
        private chRef: ChangeDetectorRef,
        private productTocService: ProductTocService,
        private productViewHelperService: ProductViewHelperService,
        private productViewDataService : ProductViewDataService,
        private networkService: NetwordDetectionService,
        private lODBHelperService: LODBHelperService,
        private customArrayOpsService : CustomArrayOpsService,
        private eventService: EventService,
        private readonly appHelperService: AppHelperService,
        private readonly router: Router,
        private readonly route: ActivatedRoute,
        private readonly pushXService: PushXService,
        private readonly customBackendLoggerService: CustomBackendLoggerService,
        private readonly createUserAnalyticsService: CreateUserAnalyticsService

    ) {
        this.orientationChangeEventListener = this.orientationChangeEventListener.bind(this);
        this.hotspotModalMouseUpEventListener = this.hotspotModalMouseUpEventListener.bind(this);
        this.addDragAndResizeHandler = this.addDragAndResizeHandler.bind(this);
     }

	async ngOnInit() {

        $('body').scroll(function(e) {
            $('body').scrollTop(0);
        });

		if (window.innerWidth < 768) {
			this._isSmallerDevice = true;
		} else {
			this._isSmallerDevice = false;
		}

        
        this.isOnline = await this.networkService.isOnline();


        window.addEventListener("orientationchange", this.orientationChangeEventListener);

        this.userProfileData = this.authService.getUserData();
        
        this.initializeLOHotspot();
	}

	// main function to initialize the modal.
	async initializeLOHotspot() {

		// update the overlay id for every new hotspot.
		this.hotspotOverlayModal = document.querySelector('#hotspot-overlay-modal-1');
		this.hotspotOverlayModal.id = 'hotspot-overlay-modal-' + this.inputConfig.selector;
		this.contentContainer = document.querySelector('.content-container');


		// set initial posiiton as center of screen
		this.resetModalToCenter();

        // get the lo vm data from db to in-memory object.
        if (this.inputConfig.data.isLinkedBookDownloaded) {
            await this.lODBHelperService.initializeLOVMObject(this.userProfileData.extUserId, this.inputConfig.data['learning-object'].courseId);
        }

		// set modal content
		this.launchLOActivity();

		this.centerAlignModalInScreen();

        this.bringLatestWidgetToTop();
		this.addDragAndResizeHandler();

        this.hotspotOverlayModal.removeEventListener('mouseup', this.hotspotModalMouseUpEventListener);
        this.hotspotOverlayModal.addEventListener('mouseup', this.hotspotModalMouseUpEventListener);

		if (this._isSmallerDevice) {
			this.toggleFullscreen(true);
		}

        if(window.innerWidth < 576 && this.userProfileData.role != 'student') {
            this.showMobileModal = true;
        } else {
            this.showMobileModal = false;
        }

	}

    hotspotModalMouseUpEventListener(e) {
        var evt = document.createEvent('HTMLEvents');
        evt.initEvent('mouseup', false, true);
        var imagebookWrapper = document.querySelector('#imgbook_wrapper');
        imagebookWrapper.dispatchEvent(evt);
    }

	// window resize event listener. use this for various resets.
	@HostListener('window:resize', ['$event'])
	onResize(event) {

		if (window.innerWidth < 768) {
			this._isSmallerDevice = true;
			this.toggleFullscreen(true);
		} else {
			this._isSmallerDevice = false;
		}

		if (this.orientationChangeCausedResize && !this.isFullscreen) {
			this.orientationChangeCausedResize = false;
			this.resetModalToCenter();
        }
        
        if(this.toggleFullscreenAgainAsOrientationWasChanged) {
            this.toggleFullscreen();
            this.toggleFullscreen();
			this.orientationChangeCausedResize = true;
        }

        if(this.centerAlignAfterOrientationWasChangedAndNotInFullscreen) {
            this.centerAlignAfterOrientationWasChangedAndNotInFullscreen = false;
            this.adjustLOContainerHeight({height:window.innerHeight, width: window.innerWidth});
            this.resetModalToCenter();
        }


        // NEMO-7429 scroll handling for ios 13
        if (window.navigator && window.navigator.userAgent) {
            let agent = window.navigator.userAgent;
            let start = agent.indexOf("OS");
            let version;

            if (agent.indexOf("iPhone") > -1 && start > -1) {
                version = agent.substr(start + 3, 3).replace("_", ".");
                if (version.indexOf("13") == 0) {
                    if(!this.isFullscreen) {
                        this.resetModalToCenter();
                    }
                }
            }
        }

        if(window.innerWidth < 576 && this.userProfileData.role != 'student') {
            this.showMobileModal = true;
        } else {
            this.showMobileModal = false;
        }
	}

	// enter fullscreen if allowed.
	// exit fullscreen if already in fullscreen.
	toggleFullscreen(state?) {

		if(state !== undefined) {
			if(state) {
				this.activateFullscreen();
			} else {
				this.deactivateFullscreen();
			}
		} else {
			if(this.isFullscreen) {
				this.deactivateFullscreen();
			} else {
				this.activateFullscreen();
			}
		}

	}

    // close overlay for mobile
    closeMobileModal() {
        this.showMobileModal = false;
    }

	// close lo from button.
	// toggle fullscreen if open in fullsceen mode.
	async closeLoHotspot() {

        this.aboutToExit = true;
        
        let xAPIRunner = this.productViewHelperService.getXAPIRunnerObject();
        let activityId = this.loActivityConfig && this.loActivityConfig.itemId;
        if(xAPIRunner && xAPIRunner.closeLO && activityId){
            await xAPIRunner.closeLO(activityId);
        }
        $('.notes-wrapper').css("z-index",1999);

		this.closeLOOutputEvent.emit(this.inputConfig.data);
        this.eventService.publishEvent(this.eventService.CONSTANTS.EREADER_EVENTS.HOTSPOT_CLOSED, {
            closeTimestamp: Date.now(),
            type: "learning-object"
        });
		this.inputConfig.component.destroy();

        this.chRef.detectChanges();

	}

	// add content to modal body.
	async launchLOActivity() {
		/* let hotspotModal: any = document.querySelector('#hotspot-overlay-modal-' + this.inputConfig.selector);
		let modalBody = hotspotModal.querySelector('.modal-body');

		let lines = Math.floor(Math.random() * 5);
		let width = Math.floor(Math.random() * 5);
		modalBody.innerHTML = '';

		for (var i = 0; i < lines; i++) {
			for (var j = 0; j < width; j++) {
				modalBody.innerHTML += 'This is modal Body ' + i + ' .'
			}
			modalBody.innerHTML += '<br/>';
        } */
        
        let data = this.inputConfig.data;

        if(!data || !data['learning-object']){
            return ;
        }

        this.productCode = data['learning-object'].courseId;

        this.itemCode = data['learning-object'].moduleId;
        console.log("this.itemCode: ", this.itemCode);

        this.classId = this.inputConfig.data.classId;
        this.isCBPClass = this.inputConfig.data.isContextBasedClass;
        this.spaceId = this.inputConfig.spaceId;

        this.productViewHelperService.setIsCBPClass(this.isCBPClass, this.classId);

        let productJSON;

        if (this.userProfileData.role == 'student') {
            try {
                productJSON = await this.productViewDataService.fetchAndStoreClassProductViewData(this.productCode,
                    {
                        classId: this.classId, assignmentId: undefined, unitCode: undefined, itemCode: this.itemCode,
                        linkedBookCode: this.inputConfig.data.linkedBookCode, isLinkedBookDownloaded: this.inputConfig.data.isLinkedBookDownloaded
                    }
                ).toPromise();
                if(productJSON.success == false && productJSON.error == 'UA_NOT_PRESENT_ERROR') {
                    this.showProgressBar = true;
                    this.handleProductViewDataFetchError();
                    return;
                };
            } catch(error) {
                return;
            }
        } else {
            productJSON = await this.productViewDataService.fetchAndStoreProductViewData(
                {
                    productCode: this.productCode, classId: this.classId, unitCode: undefined, itemCode: this.itemCode,
                    linkedBookCode: this.inputConfig.data.linkedBookCode, isLinkedBookDownloaded: this.inputConfig.data.isLinkedBookDownloaded
                }, false, false).toPromise()
        }

        this.tocArray = productJSON.toc.tocArray;
        this.productMeta = productJSON.meta.meta;
        this.bundleDetails = productJSON.bundleDetails;
        this.itemCode = productJSON.itemCode;
        this.isPEDownloaded = productJSON.isPEDownloaded;

        let dependencyBase = window.location.protocol + '//' + window.location.host + MICROAPP_BASE_URL + 'node_modules';
        if(environment.isDesktopApp){
            if(window["isDesktopAppDev"]){
                dependencyBase = window.location.protocol + '//' + window.location.host + '/node_modules';
            }else{
                dependencyBase = window["electronResourcesPath"] + '/../node_modules';
            }
        }


        let modifiedUserRole;
        if(this.userProfileData.role == 'student'){
            modifiedUserRole = 'student';
        } else {
            modifiedUserRole = 'teacher';
        }

        //Setup initialization params
        var initParams = {  
            paths: {
                dependencyBase: dependencyBase,
                contentAssetBase: this.productMeta.paths["public-assets"]
            },
            userId: this.userProfileData.extUserId,
            userRole: modifiedUserRole,
            productCode: this.productCode,
            classId: this.classId,
            isCBPClass: this.productViewHelperService.getIsCBPClass(),
        };
        //ANALYTICS - Setup initialization params & initialize analytics engine.
        let routePrefix = this.apiGatewayHelperService.getApiGatewayPrefixUrl();
        if (environment.isDesktopApp) {
            routePrefix = DesktopConfig.app.api.baseUrl + routePrefix;
        }
        var serverRoutePrefix = routePrefix.substr(0, routePrefix.length-1);

        this.productViewHelperService.setXAPIAnalyticsObject({
                serverRoutePrefix: serverRoutePrefix ,
                dlsProductCode: this.productCode, 
                spaceId : this.spaceId,
                dlsClassId: this.classId,
                dlsAssignmentId: this.assignmentId,
                userId: this.userProfileData.extUserId,
                isCBPClass: this.productViewHelperService.getIsCBPClass(),
                persistentState: { "*": true }
        });

        //Setup event handlers for receiving events from LO.
        this.xapiLOAnalytics = this.productViewHelperService.getXAPIAnalyticsObject();
        var eventCallbacks = {                
            newState: async (uniqueId, newState) => {
                //Persist state to LRS via analytics engine if user is not a teacher
                if (this.xapiLOAnalytics && this.userProfileData.role == 'student') {
					// ~~TODO~~ : save state. save to server and DB, remove from DB when sync complete from server.
                    if (this.isPEDownloaded) {
                        if(this.isOnline) {
                            this.xapiLOAnalytics.postState(uniqueId, newState);
                        }
                        await this.lODBHelperService.storeInStatesVM(this.userProfileData.extUserId, this.spaceId, this.classId, this.productCode, uniqueId, newState);
                        
                    } else {
                        this.xapiLOAnalytics.postState(uniqueId, newState);
                    }
                }
            },
            newInterpretedStatements: async (uniqueId, newInterpretedStatements) => {
                // Ignore statements in case user is a teacher
                if (this.userProfileData.role != 'student') {
                    return;
                }
                var unitId = this.selectedItem.unitId;
                var lessonId = this.selectedItem.lessonId;
                var activityId = this.selectedItem.activityId;
                var courseToc = this.productTocData.toc.tocObject;
                var verb;
                var groupId;

                var selectedUnit;
                var selectedLesson;
                var selectedActivity;

                if(unitId && lessonId) {
                    selectedUnit = courseToc[unitId];
                    selectedLesson = selectedUnit.items[lessonId];
                }
                else if(lessonId) {
                    selectedLesson = courseToc[lessonId];
                }
                selectedActivity = this.selectedItemData;

                for(var i=0; i < newInterpretedStatements.length; i++) {
                    if(newInterpretedStatements[i].json && newInterpretedStatements[i].json.verb && newInterpretedStatements[i].json.verb.id ) {
                        verb = newInterpretedStatements[i].json.verb.id;
                        if(newInterpretedStatements[i].json.group){
                            groupId = newInterpretedStatements[i].json.group.id;
                        }
                        if (verb.indexOf("launched") !== -1) {
                            if (newInterpretedStatements[i].json.object && newInterpretedStatements[i].json.object.id && newInterpretedStatements[i].json.object.id !== activityId) {
                               // If launched statement of previous LO is called after the user has changed the LO, ignore that status
                                return;
                            }
                            if (selectedActivity) {
                                if (!this.isPEDownloaded && selectedActivity.__analytics.status != 'in_complete') {
                                    this.tocArray.__analytics.itemsCount.inComplete++;
                                    if (selectedActivity.__analytics.status == 'completed') {
                                        this.tocArray.__analytics.itemsCount.completed--;
                                    }
                                }
                                
                                if (!this.isPEDownloaded) {
                                    selectedActivity.__analytics.status = 'in_complete';
                                }
                            }
                        } else if (verb.indexOf("completed") !== -1) {
                            if (newInterpretedStatements[i].json.object && newInterpretedStatements[i].json.object.id && newInterpretedStatements[i].json.object.id !== activityId) {
                               // If completed statement of previous LO is called after the user has changed the LO, ignore that status
                                return;
                            }
                            if (selectedActivity && !this.isPEDownloaded) {
                                this.tocArray.__analytics.itemsCount.completed++;
                                this.tocArray.__analytics.itemsCount.inComplete--;
                                
                                selectedActivity.__analytics.status = 'completed';
                                if (selectedActivity["sub-type"] === "ext-cup-xapiscoreable") {
                                    if (selectedActivity.__analytics.bestResult) {
                                        if (selectedActivity.__analytics.bestResult.scaledScore !== undefined) {
                                            if (newInterpretedStatements[i].json.result.score.scaled > selectedActivity.__analytics.bestResult.scaledScore) {
                                                selectedActivity.__analytics.bestResult.scaledScore = newInterpretedStatements[i].json.result.score.scaled;
                                                selectedActivity.__analytics.bestResult.min = newInterpretedStatements[i].json.result.score.min;
                                                selectedActivity.__analytics.bestResult.max = newInterpretedStatements[i].json.result.score.max;
                                                selectedActivity.__analytics.bestResult.raw = newInterpretedStatements[i].json.result.score.raw;
                                            }
                                        } else {
                                            selectedActivity.__analytics.bestResult.scaledScore = newInterpretedStatements[i].json.result.score.scaled;
                                            selectedActivity.__analytics.bestResult.min = newInterpretedStatements[i].json.result.score.min;
                                            selectedActivity.__analytics.bestResult.max = newInterpretedStatements[i].json.result.score.max;
                                            selectedActivity.__analytics.bestResult.raw = newInterpretedStatements[i].json.result.score.raw;
                                        }
                                        
                                    } else {
                                        selectedActivity.__analytics.bestResult = { 
                                            scaledScore: newInterpretedStatements[i].json.result.score.scaled,
                                            min: newInterpretedStatements[i].json.result.score.min,
                                            max: newInterpretedStatements[i].json.result.score.max,
                                            raw: newInterpretedStatements[i].json.result.score.raw
                                        };
                                    }
                                }

                                if (!selectedActivity.__analytics.completedOnce) {
                                    selectedActivity.__analytics.completedOnce = true;
                                    if (selectedActivity['contributes-to-completion'] !== false) {
                                        if(unitId && lessonId) {
                                            // Updated Lesson level Analytics
                                            selectedLesson.__analytics.itemCounts.completedAndContributeCompletion++;
                                            // Updated Unit level Analytics
                                            selectedUnit.__analytics.itemCounts.completedAndContributeCompletion++;
                                        }
                                    }
                                }
                                
                                if (!selectedActivity.__analytics.completedOnceWithSuccess && !ContentHelper.isTestContent(selectedActivity)) {
                                    selectedActivity.__analytics.completedOnceWithSuccess = true;
                                    if (selectedActivity['contributes-to-completion'] !== false) {
                                        if(unitId && lessonId) {
                                            // Updated Lesson level Analytics
                                            selectedLesson.__analytics.itemCounts.completedWithSuccessAndContributeCompletion++;
                                            // Updated Unit level Analytics
                                            selectedUnit.__analytics.itemCounts.completedWithSuccessAndContributeCompletion++;
                                        }
                                    }
                                } else if (!selectedActivity.__analytics.completedOnceWithSuccess && (selectedActivity["sub-type"] == "ext-cup-xapiscoreable" && newInterpretedStatements[i].json.result && newInterpretedStatements[i].json.result.score && newInterpretedStatements[i].json.result.score.hasOwnProperty('scaled'))) {
                                    if (newInterpretedStatements[i].json.result.score.scaled >= selectedActivity["pass-score"]) {
                                        selectedActivity.__analytics.completedOnceWithSuccess = true;
                                        if (selectedActivity['contributes-to-completion'] !== false) {
                                            if(unitId && lessonId) {
                                                // Updated Lesson level Analytics
                                                selectedLesson.__analytics.itemCounts.completedWithSuccessAndContributeCompletion++;
                                                selectedLesson.__analytics.itemCounts.completedWithSuccessTestAndContributeCompletion++;
                                                // Updated Unit level Analytics
                                                selectedUnit.__analytics.itemCounts.completedWithSuccessAndContributeCompletion++;
                                                selectedUnit.__analytics.itemCounts.completedWithSuccessTestAndContributeCompletion++;
                                            }
                                        }
                                    }                                    
                                }
                            }
                        } else if (verb.indexOf("submitted") !== -1) {
                            if (newInterpretedStatements[i].json.object && newInterpretedStatements[i].json.object.id && newInterpretedStatements[i].json.object.id !== activityId) {
                                // If completed statement of previous LO is called after the user has changed the LO, ignore that status
                                 return;
                            }
                        }
                        // Update the iconObj and scoreObj
                        this.updateLCHObjects(selectedActivity);
                        if(!this.chRef['destroyed']) {
                            this.chRef.detectChanges();
                        }
                    }
                }
                //Post Statements to LRS via analytics engine if user is not a teacher
                if (this.xapiLOAnalytics) {
                    if (verb && verb.indexOf("submitted") !== -1 || (verb.indexOf("completed") !== -1 && groupId)) {
                        // In case of submitted verb sent from pskill activities do not batch the calls
                        let options = {};
                        if(this.selectedItemData && this.selectedItemData['sub-type'] === 'cup-pskill' && this.selectedItemData[this.selectedItemData['sub-type']]['cup-options'].submissionType.id === 'speak' ) {
                            options = {
                                isSignedURLReq:  true,
                                subType: 'cup-pskill',
                                submissionTypeId: 'speak'
                            }
                        }
                        this.xapiLOAnalytics.postStatementsNoBatch(newInterpretedStatements, options).then((response)=> {
                            this.showOrHideNextActivityButton();
                            if(verb.indexOf("completed") !== -1){
                                this.productViewHelperService.collabSkillAnsSaved.next(null);
                            }
                            else{
                                let responseEntity;
                                if (response && response.entities && response.entities[0]) {
                                    responseEntity = response.entities[0];
                                }
                                let selectedResponseItem = this.getSelectedItemData(this.tocArray, responseEntity["item-code"]);
                                let analyticsData;
                                if( responseEntity && responseEntity["item-code"]) {
                                    if (selectedResponseItem) {
                                        selectedResponseItem.__analytics.status = 'in_complete';
                                        selectedResponseItem.__analytics.lastSubmitted = new Date().getTime();
                                        selectedResponseItem.__analytics.submittedOnce = true;
                                        if (responseEntity.result && responseEntity.result.response && responseEntity.result.response.text) {
                                            analyticsData={ text : responseEntity.result.response.text };
                                            if (responseEntity.result.response.attribs && responseEntity.result.response.attribs.title) {
                                                analyticsData['attribs'] = {
                                                    'title': responseEntity.result.response.attribs.title
                                                };
                                            }
                                            if (responseEntity.result.response.link) {
                                                analyticsData['link'] = responseEntity.result.response.link;
                                            }
                                        }
                                        if (responseEntity.result && responseEntity.result.response && responseEntity.result.response.audioPath) {
                                            analyticsData={ audioPath : responseEntity.result.response.audioPath };     
                                        }
                                        // Update iconObj and scoreObj
                                        this.updateLCHObjects(selectedResponseItem);
                                    }
                                }
                                this.productViewHelperService.pskillAnsSaved.next(analyticsData);
                            }                              
                        }, (error)=> {
                            if (error.responseJSON && error.responseJSON.errorCode === 'LINK_ERROR') {
                                this.productViewHelperService.pskillUrlLinkValidation.next(error);
                                return;
                            }
                            this.productViewHelperService.changesNotSaved.next(null);
                        });
                    } else if (verb && verb.indexOf("submitted") === -1) {

                    // ~~TODO~~ : Handle storing statements to server and DB. add completed state if required.
                    /**
                     * in case of completed statement, store a completed state in DB as well.
                     * do not push state to server here as it is already done by XAPI.
                     */
                        if (this.isPEDownloaded) {


                            if (this.isOnline) {
                                this.xapiLOAnalytics.postStatements(newInterpretedStatements);
                            } else {
                                await this.lODBHelperService.storeInStatementsVM(this.userProfileData.extUserId, this.spaceId, this.classId, this.productCode, uniqueId, newInterpretedStatements);
                            }

                            if (verb.indexOf("completed") > -1) {
                                await this.lODBHelperService.storeInStatesVM(this.userProfileData.extUserId, this.spaceId, this.classId, this.productCode, uniqueId, { timestamp: new Date().getTime() });
                            }
                            

                        } else {
                            this.xapiLOAnalytics.postStatements(newInterpretedStatements);
                        }
                    }
                }
            },
            containerNotification: this.loContainerNotificationHandler.bind(this)
        };
        // Initialize the Activity & setup event handlers.
        this.productViewHelperService.setXAPIRunnerObject(initParams, eventCallbacks);

        //important, subscribe and handle change in item 
        this.selectedItemSubscription = this.productViewHelperService.selectedItemId.subscribe(
            (selectedItemObject: any) => {
            // Hide all activity buttons by default when new activity launches
            this.showControls = [];
            this.selectedItem = selectedItemObject.selectedItem;
            this.selectedItemData = selectedItemObject.selectedItemData;
            this.findUnitSelected(selectedItemObject.itemid);

            // Passing loProfile to xapi for teachers
            const userRole = this.userProfileData.role == 'student'? 'student': 'teacher';
    
            if(userRole == 'teacher' && this.selectedItemData?.['sub-type']
                && this.selectedItemData?.[this.selectedItemData['sub-type']]?.['cup-options']?.['profiles']) {
    
                let loProfile = this.selectedItemData[this.selectedItemData['sub-type']]['cup-options']['profiles'];
    
                if(Array.isArray(loProfile) && loProfile.indexOf('10') != -1) {
                    this.loActivityConfig['loProfile'] = 10;
                }
    
            }

            // Show Next button immediately in download type activities
            setTimeout(()=> {
                this.isGameActivity = (selectedItemObject.selectedItemData['game'] || (this.inputConfig.data.learningPathSubType == "game")) ? true : false;

                // launch in fullscreen in case of non avallain html
                if (this.inputConfig.data.learningPathSubType !== 'answer-key') {
                    this.toggleFullscreen(true);
                }
                this.showResizers = true;

                if (ContentHelper.isDownloadableContent(selectedItemObject.selectedItemData)) {
                    // Do not show next button in case Downloadable activity is the last activity of the product
                    this.showOrHideNextActivityButton();
                }else if(ContentHelper.isSubmittableContent(selectedItemObject.selectedItemData) && selectedItemObject.selectedItemData.__analytics && selectedItemObject.selectedItemData.__analytics.submittedOnce && !selectedItemObject.selectedItemData.__analytics['reattempt-requested']){
                    this.showOrHideNextActivityButton();
                }
                else if(ContentHelper.isCollaborativeTask(selectedItemObject.selectedItemData) && selectedItemObject.selectedItemData.__analytics.completedOnce){
                    this.showOrHideNextActivityButton();
                } else if (ContentHelper.isSubmittableContent(selectedItemObject.selectedItemData)) {
                    this.showOrHideNextActivityButton();
                } else if (ContentHelper.isCollaborativeTask(selectedItemObject.selectedItemData)) {
                    this.showOrHideNextActivityButton();
                } else {
                    this.showNextActivityBtn = false;
                }
            });                
        });

        this.productTocData = productJSON;
        this.loActivityConfig = {
            productData: productJSON,
            productCode: this.productCode,
            itemId: this.itemCode,
            userRole: this.userProfileData.role,
            metaData: {
                isPEDownloaded: productJSON.isPEDownloaded,
                spaceId: this.spaceId,
                classId: this.classId,
                productCode: this.productCode,
                userRole: this.userProfileData.role,
                extUserId: this.userProfileData.extUserId
            }
        };

        this.chRef.detectChanges();
    }

    handleProductViewDataFetchError() {
        this.setProgessBarWidth(20);
        this.params = this.route.snapshot.params;
        const {userId, orgId, pubnubEventType} = this.createUserAnalyticsService.getUserOrgInfo();
        const userData = this.authService.getUserData();
        const channelId:string = this.getChannelId(pubnubEventType);
        if(userId && orgId) {
            this.pushXService.grantByOrgId(orgId, this.params.spaceId).toPromise().then(() => {
                this.setProgessBarWidth(40);
                const pushXConnection = this.pushXService.getPushXConnection(orgId);
                pushXConnection.on({ userid: userId, orgid: orgId, channel: channelId }, (sysevent) => {
                    const eventBody = sysevent?.events?.body || {};
                    this.pushXLogger(userData, 'TYPE=SYSTEM_EVENTS, Preview Product', eventBody, true).catch(e => { throw e; });
                    if((eventBody.productcode == this.productCode || eventBody.productCode == this.productCode)
                        && eventBody.userid == userId) {
                        if(eventBody.status == "success") {
                            this.setProgessBarWidth(100);
                            this.launchLOActivity();
                            this.showProgressBar = false;
                        } else if(eventBody.status == "error") {
                            this.appHelperService.navigateToDashboardApp(['error']);
                        }
                    }
                });

                pushXConnection.on({ channel: "pushx_status" }, (subscriptionStatus) => {
                    if(subscriptionStatus.category === 'PUSHX' && subscriptionStatus.type === 'CHANNEL_SUBSCRIPTION') {
                        if(subscriptionStatus.status === 'SUCCESS') {
                            this.setProgessBarWidth(60);
                            this.createUserAnalyticsService.userProductEntitlement(this.params.spaceId, this.productCode)
                            .subscribe(() => {
                                if(this.widthOfProgressBar < 80) this.setProgessBarWidth(80);
                            });
                        } else if(subscriptionStatus.status === 'ERROR') {
                            throw new Error(JSON.stringify(subscriptionStatus));
                        }
                    }
                });
            }).catch((err) => {
                console.log('error', err);
            });
        } else {
            this.appHelperService.navigateToDashboardApp(['error']);
        }
    }
    async pushXLogger(userData: any, context: string, message: string, success: boolean) {
        const logObj: any = {
            message, context,
            extUserId: userData.extUserId,
            role: userData.role,
            status: !success ? 'error' : 'success'
        };
        await this.customBackendLoggerService.logInfoToBackend(logObj).toPromise();
    }
    setProgessBarWidth(width: number) {
        this.widthOfProgressBar = width;
        if (this.progressBar && this.progressBar.nativeElement) {
            this.progressBar.nativeElement.style.width = this.widthOfProgressBar + '%';
        }
    }
    
    loContainerNotificationHandler(uniqueId, containerEvent, containerEventData) {
        console.log("containerEvent: ", containerEvent);
        // console.log("containerEventData: ", containerEventData);

        const activityEventsToBePassed = ['container_controls', 'currentScreen', 'totalScreens', 'activityClosed'];
        if (this.selectedItemData && this.selectedItemData[this.selectedItemData["sub-type"]] && this.selectedItemData[this.selectedItemData["sub-type"]].container === 'spa-container') {
            if (activityEventsToBePassed.indexOf(containerEvent) > -1) {
                this.productViewHelperService.activityEventsSubject.next({uniqueId, containerEvent, containerEventData});
            }
        }
        if (containerEvent === 'avallain_controls' || containerEvent === 'generic_controls') {
            if(containerEventData.state) {
                let isControlAlreadyExist = this.showControls.findIndex((control) => {
                    return control.type === containerEventData.control;
                });
                if (isControlAlreadyExist === -1) {
                    /* Show Button */
                    let controlData = {
                        'containerType': containerEvent,
                        'type': containerEventData.control,
                        'text': containerEventData.meta.buttonText,
                        'disable': false
                    };
                    /* set translations keys for the hardcoded buttons text that we get from xapirunner*/
                    switch(controlData.text) {
                        case 'Check': controlData.text = 'FOC.LO.TEACHER.ACTIVITYVIEW.CHECK'; break;
                        case 'Next' : controlData.text = 'FOC.LO.TEACHER.ACTIVITYVIEW.NEXT'; break;
                        case 'Review' : controlData.text = 'FOC.LO.TEACHER.ACTIVITYVIEW.REVIEW'; break;
                        case 'Previous' : controlData.text = 'FOC.LO.TEACHER.ACTIVITYVIEW.PREVIOUS'; break;
                        case 'Show all answers' : controlData.text = 'FOC.LO.TEACHER.ACTIVITYVIEW.SHOW_ALL_ANSWERS'; break;
                    }
                    /* Previous button to be shown first always and next button to be shown at the right most end always */
                    if(controlData.type === 'goPrev') this.showControls.unshift(controlData);
                    else if(controlData.type === 'goNext') this.showControls.push(controlData);
                    else {
                        const goNextIndex = this.showControls.findIndex((control) => {
                            return control.type === 'goNext';
                        });
                        if(goNextIndex !== -1) {
                            this.showControls.splice(goNextIndex, 0, controlData);
                        } else {
                            this.showControls.push(controlData);
                        }
                    }

                    /* this.showControls.push(controlData);

                    // sort buttons based on order defined in array this.controlOrder
                    this.showControls = this.customArrayOpsService
                        .sortObjArrAccording(this.showControls, this.controlOrder, "type");

                    // ensuring that goNext button is last
                    const goNextIndex = this.showControls.findIndex((control) => {
                        return control.type === 'goNext';
                    });
                    if (goNextIndex !== -1
                        && this.showControls[this.showControls.length - 1]["type"] != "goNext") {
                        let nextBtn = this.showControls[goNextIndex];
                        this.showControls.splice(goNextIndex, 1);
                        this.showControls.push(nextBtn);
                    } */
                }
            } else {
                /* Hide Button */
                this.showControls = this.showControls.filter((control) => { 
                    return control.type !== containerEventData.control;
                });
            }
        } else if (containerEvent === 'iframeEvents') {
            if (this.learningpathVisible === true) {
                this.learningpathVisible = false;
            } 
            if(containerEventData == "mouseup") {
                // this.addDragAndResizeHandler();
            }
            this.updateUserLastActivityTimestamp();
        } else if (containerEvent === 'container_controls') {
            if (containerEventData === 'activityCompleted') {
                this.showOrHideNextActivityButton();
            }else if(containerEventData === 'screenLaunched') {
                // check needed for avallain-content bugs
                let goNextControl = this.showControls.find((control) => {
                    return (control.containerType === 'avallain_controls' && control.type === 'goNext');
                });
                if(goNextControl) {
                    goNextControl.disable = false; 
                }
            }
        } else if(containerEvent === 'activityClosed') {
            // hide C1 result screen if rendered
            this.hideResultScreen();
            /*launch next activity or Show TOC and relaunch (for games) if content terminates itself
            ignore activityClosed event if close called by conatiner (logout, navigate to dashboard and click on 'tryAgain' button scenarios) */
            if (!containerEventData.isContainerCloseCalled && uniqueId === this.selectedItem.activityId) {
                if(this.isGameActivity) {
                    this.closeActivityBtn.nativeElement.click();
                }
            }
        } else if (containerEvent === 'showResults') {

            // if scoreObject is found, then the LO is relaunched with persistent flag and result screen needs to be shown.
            // result screen will require the score Object and for that the score object is fetched from service where it was stored in activity launch.
            let scoreObject = this.productViewHelperService.getScoreObject();
            this.productViewHelperService.resetScoreObject();
            if(scoreObject) {
                containerEventData.score = scoreObject
            }
            
            this.showResultScreenEvent.next(containerEventData);
            this.showResultScreen = true;
        }                    
        if (this.selectedItem.activityId) {
            this.chRef.detectChanges();
        }

        // attach mouseup event to iframe as xpi-runner unbinds it on onunload. Issue occurs on second launch of lo.
        // NEMO-5871 and NEMO-6079 : drag and resize not working
        this.addIframeMouseupEvent();
    }

    /* Function to get selected item data  */
    private getSelectedItemData(toc, itemId) {
        let activityItems = [];
        let selectedItemData;
        toc.result.some((unit, unitIndex) => {
            activityItems = this.productTocService.getLeafNodeItems(unit);
            selectedItemData = activityItems.find((activity) => {
                let itemCode = decodeURIComponent(activity['item-code']);
                return (itemId === itemCode);
            })
            return selectedItemData;
        });
        return selectedItemData;
    }

    private updateUserLastActivityTimestamp = this.debounce(() => {
        localStorage.setItem(appSetting.localStorage.userLastActivityTimestamp, Date.now() + '')
    }, 300);

    private debounce(func, timeout = 300) {
        let timer;
        return (...args) => {
            clearTimeout(timer);
            timer = setTimeout(() => { func.apply(this, args); }, timeout);
        };
    }

    // Function to relaunch activity
    relaunchActivity() {
        this.showControls = [];
        this.showNextActivityBtn = false;
        this.productViewHelperService.getXAPIRunnerObject().reLaunchLO(this.selectedItem.activityId);
    }

    updateLCHObjects(activity) {
        activity.lchObject.iconObj = this.productViewDataService.getProductContentHelper().getStatusIconForContent(activity);
        activity.lchObject.scoresObj = this.productViewDataService.getProductContentHelper().getFormattedScore(activity);
    }

    findUnitSelected (itemid): void {
        let unitid = itemid.split('/')[0];
        for(var index=0; this.tocArray.result && index<this.tocArray.result.length; index++) {            
            if (this.tocArray.result[index]['item-code'] === unitid) {
                this.selectedItem.selectedUnitIndex = index;
                break;
            }
        }
    }

    /**
     * sets next activity button if not last item
     */
    showOrHideNextActivityButton(){
        let navigationArray = this.productTocData.toc.navigationMeta;
        let currentItemIndex = navigationArray.map( (val) => val["item-code"] ).indexOf(this.selectedItem.activityId);
        if ( currentItemIndex !== navigationArray.length-1 ) {
            this.showNextActivityBtn = true;
        } else {
            this.showNextActivityBtn = false;
        }      
    }

    // Function to hide C1 rendered result screen
    hideResultScreen() {
        if (this.showResultScreen) {
            this.showResultScreen = false;
        }
    }

    /* Function to action content controls - checkAnswer/goNext/goToExerciseScreen/sendScores */
    actionControl({containerType, type}) {
        // hide C1 result screen if rendered 
        this.hideResultScreen();
        // checks needed for avallain-content bugs
        if(containerType === 'avallain_controls') {
            if(type === 'checkAnswer') {
                let checkAnswerControl = this.showControls.find((control) => {
                    return control.type === type;
                });
                if(checkAnswerControl.disable) return;
                else checkAnswerControl.disable = true;
            }
            if(type === 'goNext') {
                let goNextControl = this.showControls.find((control) => {
                    return control.type === type;
                });
                if(goNextControl.disable) return;
                else if(!this.isReviewMode) goNextControl.disable = true;
            }
            if(type === 'goToExerciseScreen') {
                this.isReviewMode = true;
                this.showNextActivityBtn = false;
            }
        }
        // checks needed for generic-avallain-content bugs
        if(containerType === 'generic_controls') {
            if(type === 'reviewAnswers' || type === 'goPrev') {
                this.showNextActivityBtn = false;
            }
        }
        // Action Control
        this.productViewHelperService.getXAPIRunnerObject().containerInvocation(this.selectedItem.activityId, containerType, {type});
    }

	// reset the drag and resize values and center the modal.
	resetModalToCenter() {
		

		// reset height and width to fit-content instead of newly calculated width and height upon reset.
        // this.hotspotOverlayModal.style.height = 'fit-content';
        if(window.innerHeight < 576) {
            this.hotspotOverlayModal.style.height = window.innerHeight + 'px';
        }

		// set initial posiiton as center of screen
		this.position = { x: this.contentContainer.offsetWidth / 2 - this.hotspotOverlayModal.offsetWidth / 2, y: this.contentContainer.offsetHeight / 2 - this.hotspotOverlayModal.offsetHeight / 2 };
		this.hotspotOverlayModal.style.transform = `translate(${this.position.x}px, ${this.position.y}px)`;
		this.hotspotOverlayModal.setAttribute('data-x', this.position.x);
		this.hotspotOverlayModal.setAttribute('data-y', this.position.y);
	}

	// translate and center the modal with updated height and width.
	centerAlignModalInScreen() {

		let availableWidth = this.contentContainer.offsetWidth - this.hotspotOverlayModal.getBoundingClientRect().width;
		let availableHeight = this.contentContainer.offsetHeight - this.hotspotOverlayModal.getBoundingClientRect().height;

		this.position = { x: availableWidth / 2, y: availableHeight / 2 };
		this.hotspotOverlayModal.style.transform = `translate(${this.position.x}px, ${this.position.y}px)`;
		this.hotspotOverlayModal.setAttribute('data-x', this.position.x);
		this.hotspotOverlayModal.setAttribute('data-y', this.position.y);

	}

	// adding drag and resize event listeners and handlers using interactjs.
	addDragAndResizeHandler() {

		// drag and resize handling
		let that = this;
        if(this.draggableModal) {
            this.draggableModal.unset();
            this.returnBecauseOriginalListenersNowWork = false;
        }

        this.draggableModal = interact('#hotspot-overlay-modal-' + this.inputConfig.selector).draggable({
			allowFrom: ".draggable-area-lo",

			listeners: {
				start (event) {
                    that.bringLatestWidgetToTop();
                    that.customDragResize = true;
                    that.returnBecauseOriginalListenersNowWork = true;
                },
				move(event) {
					that.position.x += event.dx;
					that.position.y += event.dy;
					event.target.style.transform = `translate(${that.position.x}px, ${that.position.y}px)`;
					// update the posiion attributes
					event.target.setAttribute('data-x', that.position.x);
					event.target.setAttribute('data-y', that.position.y);
				}
			},
			restrict: {
				restriction: '.content-container',
				elementRect: { top: 0, left: 0, bottom: 1, right: 1 }
			},
		})
        .resizable({
            edges: {
                top: ['.top-resizer', '.top-left-resizer','.top-right-resizer'],		// Use pointer coords to check for resize.
                left: ['.left-resizer', '.top-left-resizer','.bottom-left-resizer'],	// Disable resizing from left edge.
                bottom: ['.bottom-resizer', '.bottom-left-resizer','.bottom-right-resizer'],	// Resize if pointer target matches selector
                right: ['.right-resizer', '.bottom-right-resizer','.top-right-resizer'], 	// Resize if pointer target is the given Element
            },
            listeners: {
                move(event) {
                    that.customDragResize = true;
                    that.returnBecauseOriginalListenersNowWork = true;

                    var target = event.target;

                    var x = (parseFloat(target.getAttribute('data-x')) || 0);
                    var y = (parseFloat(target.getAttribute('data-y')) || 0);

                    // update the element's style
                    target.style.width = event.rect.width + 'px';
                    target.style.height = event.rect.height + 'px';

                    // translate when resizing from top or left edges
                    x += event.deltaRect.left;
                    y += event.deltaRect.top;
                    
                    that.position.x = x;
                    that.position.y = y;

                    target.style.webkitTransform = target.style.transform = 'translate(' + x + 'px,' + y + 'px)';

                    target.setAttribute('data-x', x);
                    target.setAttribute('data-y', y);
                }
            },
            modifiers: [
                // hardcoding min size as it was getting reset for each iframe mouseup issue fix
                interact.modifiers.restrictSize({
                    min: { width: 361, height: 250 },
                }),
                interact.modifiers.restrictEdges({
                    outer: '.content-container'
                }),
            ],
            inertia: true
        });

        this.chRef.detectChanges();
    }
    
    disableDragAndResize() {
        interact('#hotspot-overlay-modal-' + this.inputConfig.selector).draggable(false).resizable(false);
    }

    enableDragAndResize() {
        interact('#hotspot-overlay-modal-' + this.inputConfig.selector).draggable(true).resizable(true);
    }

	// function to enter into fullscreen mode using css and 100% viewport.
	activateFullscreen() {
		
		if(this.isFullscreen) {
			return;
        }
        
        this.bringLatestWidgetToTop();

		let draggableArea: any = this.hotspotOverlayModal.querySelector('.draggable-area-lo');
        let toc = document.querySelector('.sidebar');
        let notes = document.querySelector('.notes-wrapper');

		this.isFullscreen = true;

		draggableArea.classList.add('fullscreen');

		this.hotspotOverlayModal.classList.add('fullscreen');
        this.hotspotOverlayModal.parentElement.classList.add('fullscreen');
        if(toc || notes) {
            
            if(this._isSmallerDevice) {
                this.hotspotOverlayModal.parentElement.parentElement.classList.add('fullscreen-lo-toc-smaller');
            } else if(toc) {
                let side = toc.classList.contains('toc-left') ? 'lo-toc-left' : 'lo-toc-right';
                this.hotspotOverlayModal.parentElement.classList.add(side);
            } else if(notes) {
                let noteSide = notes.classList.contains('notes-right') ? 'lo-toc-right' : 'lo-toc-left';
                $('.notes-wrapper').css("z-index",0);
                this.hotspotOverlayModal.parentElement.classList.add(noteSide);
            }
        }

        this.disableDragAndResize();
	}

	// function to exit from fullscreen mode using using css and 100% viewport.
	deactivateFullscreen() {

		if(!this.isFullscreen) {
			return;
		}

		let draggableArea: any = this.hotspotOverlayModal.querySelector('.draggable-area-lo');

		this.isFullscreen = false;
        
        $('.notes-wrapper').css("z-index",1999);

		draggableArea.classList.remove('fullscreen');

		this.hotspotOverlayModal.classList.remove('fullscreen');
        this.hotspotOverlayModal.parentElement.classList.remove('fullscreen');
        this.hotspotOverlayModal.parentElement.classList.remove('lo-toc-left');
        this.hotspotOverlayModal.parentElement.classList.remove('lo-toc-right');
        this.hotspotOverlayModal.parentElement.parentElement.classList.remove('fullscreen-lo-toc-smaller');
        
		if(this.orientationChangeCausedResize) {
            this.orientationChangeCausedResize = false;
            this.adjustLOContainerHeight({height:window.innerHeight, width: window.innerWidth});
			this.resetModalToCenter();
        } else if(!this.customDragResize) {
            this.resetModalToCenter();
        }
        
        this.enableDragAndResize();
	}

	functionTriggeredFromBB() {
        // empty function
        // used as placeholder for future needs
	}

	async ngOnDestroy() {
        window.removeEventListener("orientationchange", this.orientationChangeEventListener);
        this.hotspotOverlayModal.removeEventListener('mouseup', this.hotspotModalMouseUpEventListener);
        let loiFrame = this.hotspotOverlayModal && this.hotspotOverlayModal.getElementsByTagName('iFrame')[0];
        loiFrame && loiFrame.contentDocument && loiFrame.contentDocument.removeEventListener('mouseup', this.addDragAndResizeHandler);
		this.closeLOOutputEvent.emit(this.inputConfig.data);
        this.selectedItemSubscription && this.selectedItemSubscription.unsubscribe();
        // Removed xapiLOAnalytics object so that no analytics call is made when user is leaves activity-view component
        this.xapiLOAnalytics = undefined;
        
        this.lODBHelperService.resetCurrentStatementsVM();
        this.lODBHelperService.resetCurrentStatesVM();

        this.productViewHelperService.resetScoreObject();

        $('body').off('scroll');
	}

	bringLatestWidgetToTop() {
        this.zIndexConfig.loZindex = this.zIndexConfig.topLayer;
        this.bringLoWidgetOnTop.emit('hotspot-overlay-modal-' + this.inputConfig.selector);
    }

    restoreDefaultZIndex() {
        this.zIndexConfig.loZindex = this.zIndexConfig.midLayer;
    }

    /* Function to return true for all control types for which control needs to be shown in green */
    isControlToBeShownGreen(type) {
        switch (type) {
            case 'checkAnswer':
            // case 'goNext':
            case 'goToExerciseScreen':
            // case 'sendScores':
            case 'checkAnswers':
            case 'reviewAnswers':
            // case 'goPrev': 
            return true;
            default: return false;
        }
    }

    // set modal body to given height + correction
    adjustLOContainerHeight(size) {

        if(size == undefined || size.height == undefined || size.height == 0 || this.customDragResize) {
            return;
        }

        // TODO : If required, use height of modal titlebar and modal footer to replace 110 number below.
        let modalBody:any = this.hotspotOverlayModal.querySelector('.modal-body');
        let modalTitle:any = this.hotspotOverlayModal.querySelector('.modal-titlebar');
        /* let modalFooter:any = this.hotspotOverlayModal.querySelector('.modal-footer'); */
        let extraHeight = modalTitle.offsetHeight /* + (modalFooter.offsetHeight || 50) */;

        if(size.height + extraHeight > 576) {
            this.hotspotOverlayModal.style.height = 'fit-content';
        }

        // added extra 4 to account for border
        if(size.height > this.contentContainer.offsetHeight - extraHeight - 4) {
            size.height = this.contentContainer.offsetHeight - extraHeight - 4;
        }

        modalBody.style.height = size.height + 'px';
        this.centerAlignModalInScreen();

    }


    updateLoForTocToggle(isTocActive, size) {

        let tocWidth = size || 160;

        if(isTocActive) {
            this.position = { x: this.position.x - tocWidth, y: this.position.y };
        } else {
            this.position = { x: this.position.x + tocWidth, y: this.position.y };
        }
        this.hotspotOverlayModal.style.transform = `translate(${this.position.x}px, ${this.position.y}px)`;
        this.hotspotOverlayModal.setAttribute('data-x', this.position.x);
        this.hotspotOverlayModal.setAttribute('data-y', this.position.y);

    }

    // add a custom mouseup event listener for iframe in lo.
    addIframeMouseupEvent() {
        let loiFrame = this.hotspotOverlayModal && this.hotspotOverlayModal.getElementsByTagName('iFrame')[0];
        if(!loiFrame){
            return;
        }
        // Do not attach event listeners if already attached.
        if (!!loiFrame.contentDocument && !!loiFrame.contentDocument.onmouseup) {
            return;
        }
        loiFrame.contentDocument && loiFrame.contentDocument.addEventListener('mouseup', this.addDragAndResizeHandler);
    }

    tocOpenWidgetHandling(detailObject) {

        const tocWidth = 320;

        let outerContainer:any = document.querySelector('.outer-container');
        let isContentScrollable = Math.abs(outerContainer.offsetWidth - outerContainer.scrollWidth) > 1 ? true : false;

        let timerOverlayBoundingRect = this.hotspotOverlayModal.getBoundingClientRect();
        let contentContainerBoundingRect = this.contentContainer.getBoundingClientRect();


        if(isContentScrollable) {

            if(detailObject.tocPosition == 'left') {
            
                if(timerOverlayBoundingRect.right > contentContainerBoundingRect.right) {
                    this.position.x -= (timerOverlayBoundingRect.right - contentContainerBoundingRect.right);
                } else {

                    if(timerOverlayBoundingRect.right + tocWidth/2 > contentContainerBoundingRect.right) {
                        this.position.x += Math.abs(timerOverlayBoundingRect.right - contentContainerBoundingRect.right);
                    } else {
                        this.position.x += tocWidth/2;
                    }

                }
                this.hotspotOverlayModal.style.transform = `translate(${this.position.x}px, ${this.position.y}px)`;
                this.hotspotOverlayModal.setAttribute('data-x', this.position.x);
                this.hotspotOverlayModal.setAttribute('data-y', this.position.y);
                
            } else if(detailObject.tocPosition == 'right') {
            
                if(timerOverlayBoundingRect.left < contentContainerBoundingRect.left) {
                    this.position.x += (contentContainerBoundingRect.left - timerOverlayBoundingRect.left);
                } else {
                    if(timerOverlayBoundingRect.left - tocWidth/2 < contentContainerBoundingRect.left) {
                        this.position.x -= Math.abs(timerOverlayBoundingRect.left - contentContainerBoundingRect.left);
                    } else {
                        this.position.x -= tocWidth/2;
                    }
                }
                this.hotspotOverlayModal.style.transform = `translate(${this.position.x}px, ${this.position.y}px)`;
                this.hotspotOverlayModal.setAttribute('data-x', this.position.x);
                this.hotspotOverlayModal.setAttribute('data-y', this.position.y);

            }

        } else {

            if(timerOverlayBoundingRect.right > contentContainerBoundingRect.right) {
                this.position.x -= (timerOverlayBoundingRect.right - contentContainerBoundingRect.right);
            }else if(timerOverlayBoundingRect.left < contentContainerBoundingRect.left) {
                this.position.x += (contentContainerBoundingRect.left - timerOverlayBoundingRect.left );
            }
            this.hotspotOverlayModal.style.transform = `translate(${this.position.x}px, ${this.position.y}px)`;
            this.hotspotOverlayModal.setAttribute('data-x', this.position.x);
            this.hotspotOverlayModal.setAttribute('data-y', this.position.y);
                
        }


    }

    tocCloseWidgetHandling(detailObject) {
        
        const tocWidth = 320;

        let timerOverlayBoundingRect = this.hotspotOverlayModal.getBoundingClientRect();
        let contentContainerBoundingRect = this.contentContainer.getBoundingClientRect();

        if(detailObject.wasContentScrollable) {

            if(detailObject.lastTocPosition == 'left') {

                if(timerOverlayBoundingRect.right + tocWidth/2 >= contentContainerBoundingRect.right) {
                        // empty if block
                        // requirements changed
                } else {
                    this.position.x -= tocWidth/2;
                }
                this.hotspotOverlayModal.style.transform = `translate(${this.position.x}px, ${this.position.y}px)`;
                this.hotspotOverlayModal.setAttribute('data-x', this.position.x);
                this.hotspotOverlayModal.setAttribute('data-y', this.position.y);
                
            } else if(detailObject.lastTocPosition == 'right') {

                if(timerOverlayBoundingRect.left - tocWidth/2 <= contentContainerBoundingRect.left) {
                        // empty if block
                        // requirements changed
                } else {
                    this.position.x += tocWidth/2;
                }
                this.hotspotOverlayModal.style.transform = `translate(${this.position.x}px, ${this.position.y}px)`;
                this.hotspotOverlayModal.setAttribute('data-x', this.position.x);
                this.hotspotOverlayModal.setAttribute('data-y', this.position.y);

            }

        }

    }

    orientationChangeEventListener() {
        this.orientationChangeCausedResize = true;
        if(this.isFullscreen) {
            this.toggleFullscreenAgainAsOrientationWasChanged = true;
        } else {
            this.centerAlignAfterOrientationWasChangedAndNotInFullscreen = true;
        }
    }

    /**
     * @param pubnubEventType 
     * @returns channelId
     * @description This function is used to get the channelId based on the pubnubEventType
     * issue: https://3.basecamp.com/4489886/buckets/20201480/messages/7080965318#__recording_7654396267
     * Fix suggestion: https://3.basecamp.com/4489886/buckets/20201480/messages/7080965318#__recording_7731460768
     */
    getChannelId(pubnubEventType: string) {
        let channelId = 'systemevents.';
        if(pubnubEventType === 'NORMAL_CLASS') {
            channelId += 'PRODUCT.USERDATA_ADD';
        } else if(pubnubEventType === 'GROUP_ENBALED_OR_CONTEXT_CLASS') {
            channelId += 'CLASS_AGGREGATION.USER_ENROLLMENT_ADD';
        }
        return channelId;
    }

}